/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */

import Models from "./models";





class Accounts extends Models{
    constructor(params) {
         super(params);
        
        

    this.setParameters(params);

    
        }
    
    
    setParameters(params){
            for (var prop in params){
                if (params.hasOwnProperty(prop)){
                    var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                    if (this[method]){
                       this[method](params[prop]);
                    }
                    
                }
            }

        }
        
         setAccountType(val){
            this.accountType = val;
         }
        
         setDocuments(arr){
            this.documents = arr;
         }
         setPerms(arr){
            this.perms = arr;
         }
         setRoles(arr){
            this.roles = arr;
         }
         setRoleOptions(obj){
            this.roleOptions = obj;
         }
         setStatus(val){
           this.status = val;
        }


   
        }
export default Accounts;
          